module.exports = new __parcel__URL__("video.cee0f850.svg").toString();